export default __webpack_public_path__ + "files/143c1e0ff3537f9edd72dd8f1fc3e0a8.mp3";